export default "__VITE_ASSET__B9Bv9s3W__"